import axios, { AxiosError } from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

export const addressApi = axios.create({
  baseURL: process.env.REACT_APP_ADDRESS_API,
})

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 418) {
      window.localStorage.removeItem('@RepfyProvider: accessToken');
      window.localStorage.removeItem('@RepfyProvider: DocumentsApproved');
      window.localStorage.removeItem('@RepfyProvider: isGuest');
      window.localStorage.removeItem('@RepfyProvider: refreshToken');
      window.localStorage.removeItem('@RepfyProvider: user');
      window.location.href = '/';
    }
    return Promise.reject(error);
});

export default api;
